import React from "react";
import { useTranslation } from "react-i18next";
import {globalContactCta} from "@/shared/FunctionCore";
import "@/app/pages/contactProfile/HooversModal/ModalStyles.scss";
import FloatingContactOptionsComponent from "@/components/overlay/FloatingContactOptions";
import {contactFormData} from "@/app/pages/contactProfile/HooversModal/ContactFormData";
// import paperPlaneIcon from "@/assets/icons/svg/paper-plane.svg";
// import rocketIcon from "@/assets/icons/svg/rocket-mail.svg";
const talkToSales = () => {globalContactCta.togglePanel();}

interface HooversModalProps {
    "onClickModalButton": (type: "close" | "open") => void;
    "showModal": boolean;
}

const HooversModal = (props: HooversModalProps): JSX.Element => {
    const
        {
            onClickModalButton,
            showModal
        } = props;

    const contactName = window["___CONTACT_NAME_FOR_HOOVERS_MODAL___"];
    const hooversSignupPath = window["___HOOVERS_SIGNUP_PATH_FOR_HOOVERS_MODAL___"];
    const { t } = useTranslation();
    const hooversFreeTrial = t("contactProfile.hooversOrangeBanner.buttonLink");

    return (
        <>
            <FloatingContactOptionsComponent properties={contactFormData} />
            {showModal ? <div className="_modal" /> : <></>}

            <div className={showModal ? "popup-overlay-active" : "popup-overlay"}>
                <button
                    className="float-right close-button"
                    onClick={() => onClickModalButton("close")}
                    type="button" />

                <div className="popup-content-data">
                    <div className="text-center modal-header">
                        To access

                        {" "}

                        {contactName}
                        &apos;s phone, email and related contacts, choose the path that works best for your business.
                    </div>

                    <div>
                        <div className="icons-section">
                            <div className="col-lg-6 col-md-6 col-sm-12 col-xs-12 edit-section">
                            <div className="hoovers-trial"/>

                                <p className="hoovers-modal-text">
                                    D&B Hoovers Essentials
                                </p>
                                <p className="hoover-desc"> Your individual prospecting platform​</p>
                                <a
                                    className="anchor modal-btn install-now ext-icon-links"
                                    href={t("contactProfile.hooversStartNow")}
                                    rel="noreferrer"
                                    target="_blank">
                                    Start Now
                                </a>
                            </div>

                            <hr className="modal-horizontal" />

                            <div className="col-lg-6 col-md-6 col-sm-12 col-xs-12 email-section">
                            <div className="getemail-io-install" />
                                
                                <p className="hoovers-modal-text">
                                D&B Hoovers
                                </p>
                                <p className="hoover-desc">Your tailor-suited growth solution</p>
                                <a
                                    className="anchor modal-btn ext-icon-links"
                                    href={t("contactProfile.hooversTryToday")}
                                    rel="noreferrer"
                                    target="_blank">
                                    Try Today
                                </a>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </>
    );
};

export default HooversModal;
